import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { type TollFreeAddNumberRoutesSteps } from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { useProgressInfoAddNumberTitle } from 'pages/settings/pages/compliance/pages/tollFree/hooks/useProgressInfoAddNumberTitle'

export const TollFreeAddNumberStepsLayout = observer(() => {
  const {
    closeSetting,
    tollFreeAddNumberNavigationStore: {
      allStepsLength,
      setCurrentStep,
      getSettingsStep,
      decreaseStep,
      tollFreeNumbers,
    },
  } = useTollFreeStepsContext()
  const settingsStep = useGetStep<TollFreeAddNumberRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoAddNumberTitle()
  const title = tollFreeNumbers.length ? 'Add toll-free number' : 'Buy toll-free number'

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep])

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title={title}
      settingsStep={settingsStep}
      closeSetting={closeSetting}
      decreaseStep={decreaseStep}
    />
  )
})
